import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Collapsible from 'react-collapsible';
import { AiFillCaretLeft, AiFillCaretRight, AiFillCaretDown } from "react-icons/ai";
import '../Styles/Sidebar.css';
import PercentageBar from './PercentageBar';

const c1 = 1;

const Sidebar = (props) => {
        return (
            <div className="sidebar">
                <div className='collapse'>
                    <Collapsible trigger={<span><AiFillCaretRight/>About “Mapping World Religions”</span>}
                    triggerWhenOpen={<span><AiFillCaretDown/>About “Mapping World Religions”</span>}>
                        <p>
                        </p>
                    </Collapsible>
                    <Collapsible trigger={<><AiFillCaretRight/>How We Did It?</>}
                    triggerWhenOpen={<><AiFillCaretDown/>How We Did It?</>}>
                        <p>
                        </p>
                    </Collapsible>
                    <Collapsible trigger={<><AiFillCaretRight/>Trying Out Different Point Of Views</>}
                    triggerWhenOpen={<><AiFillCaretDown/>Trying Out Different Point Of Views</>}>
                        <p>
                            This is the collapsible content. It can be any element or React
                            component you like.
                        </p>
                        <p>
                            It can even be another Collapsible component. Check out the next
                            section!
                        </p>
                    </Collapsible>
                    <Collapsible trigger={<><AiFillCaretRight/>Sub-Dominant Religions' Situations</>}
                    triggerWhenOpen={<><AiFillCaretDown/>Sub-Dominant Religions' Situations</>}>
                        <p>
                            This is the collapsible content. It can be any element or React
                            component you like.
                        </p>
                        <p>
                            It can even be another Collapsible component. Check out the next
                            section!
                        </p>
                    </Collapsible>
                    <Collapsible trigger={<><AiFillCaretRight/>Geo-Political Bodies In Focus</>}
                    triggerWhenOpen={<><AiFillCaretDown/>Geo-Political Bodies In Focus</>} open>
                        
                    </Collapsible>
                    
                </div>
                <div className='religionProfile' style={{bottom:"0"}}>
                    <div className="religionPageInfoDisplay">
                        <div><b>{props.country} {props.province}</b></div>
                        <div><b>Dominant Religion:</b><br /> {props.firstReligion}</div>
                        <div><b>Sub-dominant Religion:</b><br /> {props.secondReligion||"none"}</div>
                        <div style={{lineHeight:"12px",fontSize:"8px"}}>Data Source: <br/>
                        <a href={props.dataURL}>{props.dataSource}</a></div>
                    </div>
                 </div>
                {/* <div className="religions">
                    <h3>Pick a Religion</h3>
                    <Link to="/" style={{textDecoration:"none"}}><div><div className='sideIcon buddhism'></div>Buddhism</div></Link>
                    <Link to="/Christianity" style={{textDecoration:"none"}}><div><div className='sideIcon christianity'></div>Christianity</div></Link>
                    <Link to="/EastAsian" style={{textDecoration:"none"}}><div><div className='sideIcon eastasian'></div>East Asian </div></Link>
                    <Link to="/Hinduism" style={{textDecoration:"none"}}><div><div className='sideIcon hinduism'></div>Hinduism</div></Link>
                    <Link to="/Islam" style={{textDecoration:"none"}}><div><div className='sideIcon islam'></div>Islam</div></Link>
                    <Link to="/Other" style={{textDecoration:"none"}}><div><div className='sideIcon other'></div>Others</div></Link>
                </div>
                <div className="continents">
                    <h3>Pick a Continent</h3>
                    <div><div className='sideIcon'></div>Africa</div>
                    <div><div className='sideIcon'></div>Asia</div>
                    <div><div className='sideIcon'></div>Australia</div>
                    <div><div className='sideIcon'></div>Europe</div>
                    <div><div className='sideIcon'></div>North America</div>
                    <div><div className='sideIcon'></div>South America</div>
                </div>
                <div className="countries">
                    <h3>Pick a Country</h3>
                    <div><div className='sideIcon'></div>Australia</div>
                    <div><div className='sideIcon'></div>Belgium</div>
                    <div><div className='sideIcon'></div>Canada</div>
                    <div><div className='sideIcon'></div>France</div>
                    <div><div className='sideIcon'></div>Germany</div>
                    <div><div className='sideIcon'></div>Greece</div>
                    <div><div className='sideIcon'></div>Italy</div>
                    <div><div className='sideIcon'></div>Japan</div>
                    <div><div className='sideIcon'></div>Netherlands</div>

                </div> */}
            </div>
                
        )
}

export default Sidebar;